import React, { useEffect, useState } from 'react';
import { BsBoxSeam } from 'react-icons/bs';
import axios from 'axios';
import { BASE_URL, USER_URL } from '../../constant/api';
import SellerHeroBanner from '../../components/Seller/SellerHeroBanner/SellerHeroBanner';
import TotalCard from '../../components/Seller/TotalCard/TotalCard';
import StockUploadModal from '../../components/Seller/StockUploadModal/StockUploadModal';
import SellerChart2 from '../../components/SellerChart2/SellerChart2';
import { FaRegCalendarAlt } from "react-icons/fa";
import ScaleLoader from 'react-spinners/ScaleLoader';

function SellerStocks() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeProductId, setActiveProductId] = useState(null);
  const [productsListed, setProductsListed] = useState([]);
  const [totalSales, setTotalSales] = useState([]);
  const [totalOrders, setTotalOrders] = useState([]);
  const [totalCustomers, setTotalCustomers] = useState([]);
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(true); // Loading state

  const title = "Stocks";
  const description = "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.";
  const totals = [
    { label: "Units Sold", value: 20, bg: "bg-green-200" },
    { label: "Units Left", value: 30, bg: "bg-blue-200" },
  ];



  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await USER_URL.get(`/products/seller/`);
        if (response.data.Status === '1') {
          setProducts(response.data.Data);
          // console.log(response.data.Data);
        }
      } catch (error) {
        console.error('Error fetching products:', error);
      } finally {
        setIsLoading(false); // Stop loading
      }
    };
    fetchProducts();
  }, [isModalOpen]);

  const fetchData = async (url, setter) => {
    try {
      const response = await USER_URL.get(url);
      setter(response.data.data || []);
      console.log(response.data.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchData(`/products/seller/total-products/`, setProductsListed);
    fetchData(`/orders/seller/revenue/`, setTotalSales);
    fetchData(`/orders/seller/total-order-count/`, setTotalOrders);
    fetchData(`/orders/seller/customers/`, setTotalCustomers);
  }, []);

  return (
    <div className="container mx-auto p-2">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-4">
        {Array.isArray(totalSales) && totalSales.length > 0 ? (
          totalSales.map((item, index) => (
            <TotalCard
              key={`total-sales-${index}`}
              label="Total Sales"
              value={item.total_revenue || 0}
              bg="bg-red-200"
            />
          ))
        ) : (
          <TotalCard key="no-total-sales" label="Total Sales" value={0} bg="bg-red-200" />
        )}

        {Array.isArray(totalOrders) && totalOrders.length > 0 ? (
          totalOrders.map((item, index) => (
            <TotalCard
              key={`total-orders-${index}`}
              label="Total Orders"
              value={item.total_orders || 0}
              bg="bg-blue-200"
            />
          ))
        ) : (
          <TotalCard key="no-total-orders" label="Total Orders" value={0} bg="bg-blue-200" />
        )}

        {Array.isArray(totalCustomers) && totalCustomers.length > 0 ? (
          totalCustomers.map((item, index) => (
            <TotalCard
              key={`total-customers-${index}`}
              label="Total Customers"
              value={item.total_customers || 0}
              bg="bg-green-200"
            />
          ))
        ) : (
          <TotalCard key="no-total-customers" label="Total Customers" value={0} bg="bg-green-200" />
        )}

        {Array.isArray(productsListed) && productsListed.length > 0 ? (
          productsListed.map((item, index) => (
            <TotalCard
              key={`product-${index}`}
              label="Products Listed"
              value={item.total_products || 0}
              bg="bg-yellow-200"
            />
          ))
        ) : (
          <TotalCard key="no-products-listed" label="Products Listed" value={0} bg="bg-yellow-200" />
        )}
      </div>


      {/* Table Section */}
      <div className="overflow-x-auto">
        {isLoading ? ( // Show loading spinner
          <div className="flex justify-center items-center h-64">
            <ScaleLoader color="#FFAE00" height={40} />
          </div>
        ) : products.length === 0 ? ( // Show no products message
          <div className="text-center mt-10">
            <BsBoxSeam className="text-6xl text-gray-400 mx-auto mb-4" />
            <p className="text-lg text-gray-600">No products available</p>
          </div>
        ) : (
          <>
            {/* Table Header */}
            <div className="w-full space-y-4 mt-10">
                  <div className="min-w-[800px] grid grid-cols-[4rem,2fr,1.5fr,1.5fr,1fr,2fr,1fr,1fr] font-medium text-brand-button-green-bg">
                <div className="text-center">Item No</div>
                <div className="text-center">Product Name</div>
                    <div className="text-center">Product Code</div>
                <div className="text-center">Added Date</div>
                <div className="text-center">Amount</div>
                <div className="text-center">Stock Status</div>
                <div className="text-center">Stock</div>
              </div>
            </div>

            {/* Table Body */}
            {products.map((product, index) => (
              <div
                key={product.id}
                className="grid text-[#2F2E41]  min-w-[800px] grid-cols-[4rem,2fr,1.5fr,1.5fr,1fr,2fr,1fr,1fr] items-center gap-2 py-2"
              >
                <div className="border rounded-xl p-2 text-center line-clamp-1 hover:line-clamp-none">{index + 1}</div>
                <div className=" rounded-xl border p-2 text-center line-clamp-1 hover:line-clamp-none">{product.name}</div>
                <div className=" rounded-xl border p-2 text-center line-clamp-1 hover:line-clamp-none">      {product.product_code}</div>
                <div className="flex flex-row justify-between items-center border p-2 rounded-xl text-center">
                  {new Date(product.created_at).toLocaleDateString('en-GB')}
                  <FaRegCalendarAlt />
                </div>
                <div className="border line-clamp-1 hover:line-clamp-none  p-2 rounded-xl text-center">{product.price}</div>
                <div className="border line-clamp-1 hover:line-clamp-none  p-2 rounded-xl text-center">
                  {product.stock_status ? "In Stock" : "Out of Stock"}
                </div>
                <div className="border line-clamp-1 hover:line-clamp-none p-2 rounded-xl text-center">{product.stock}</div>
                <div className="border bg-brand-primary text-sm text-white p-3 rounded-xl text-center">
                  <button
                    onClick={() => {
                      setActiveProductId(product.id);
                      setIsModalOpen(true);
                    }}
                  >
                    Add stock
                  </button>
                </div>

                {isModalOpen && activeProductId === product.id && (
                  <StockUploadModal
                    isOpen={isModalOpen}
                    setIsOpen={setIsModalOpen}
                    id={product.id}
                  />
                )}
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  );
}

export default SellerStocks;
